<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <!-- CONTENT -->
    <div class="content" [ngClass]="this.view" style="overflow-y: scroll;">

        <div class="cards" fxLayout="row wrap" fxLayout.xs="column wrap">
            <div class="card" *ngFor="let resource of resources" fxFlex="33.3">
                <!-- PREVIEW -->
                <div class="card-preview" fxFlex="100">

                    <div class="fuse-card" fxFlex="100">

                        <div class="p-16" fxLayout="row" fxLayoutAlign="space-between start">
                            <div class="h1">{{resource.name}}</div>
                            <div class="h4 secondary-text">
                                <table>
                                    <tr>
                                        <td style="text-align: right;">{{'In use'|translate}}:</td>
                                        <td style="text-align: left;">
                                            <b>{{resource.assignedUser.firstName}} {{resource.assignedUser.lastName}}</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right;">{{'Card number'|translate}}:</td>
                                        <td style="text-align: left;"><b>{{resource.assignedCard.cardNumber}}</b></td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right;">{{'Started at'|translate}}:</td>
                                        <td style="text-align: left;">
                                            <b>{{resource.assignedFrom|date: 'dd.MM.y HH:mm:ss': 'UTC+2': locale}}</b>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div class="p-16 pt-0 line-height-1.75">

                        </div>

                        <div class="p-8 pt-0" fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <!--                                    <a mat-button color="accent" routerLink="/customers/cards/{{card.uuid}}/history/{{user.id}}">{{'HISTORY'|translate}}</a>-->
                                <!--                                    <a mat-button color="accent" routerLink="/customers/cards/{{card.id}}/add-item/{{user.id}}" [routerLinkActive]="[]">{{'ADD SERVICE'|translate}}</a>-->
                                <!--                                <a mat-button color="accent">{{'LOCK'|translate}}</a>-->
                            </div>
                        </div>

                    </div>

                </div>
                <!-- / PREVIEW -->
            </div>


        </div>
    </div>
</div>
